export default ({ COLORS }) => ({
  message: {
    color: COLORS.TEXT.LIGHT_GREY.NORMAL,
    margin: '20px 0 0',
    display: 'flex',
    alignItems: 'center'
  },
  icon: {
    marginRight: '5px'
  }
})
